import { displayAnalyticsPage } from "./displays/display-analytics-page";

export default function showAnalytics() {
  displayAnalyticsPage();
}
